import React from 'react';
import styles from './Card.module.scss';

const Card = ({ heading = '', description = '', icon, children }) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <span className={styles.heading}>{heading}</span>
        </div>

        {description && <div className={styles.description}>{description}</div>}
      </div>

      {children}
    </div>
  );
};

export default Card;
